/**
 * StepName — Wizard Step 1 (ONBOARDING_FLOW).
 *
 * Text input for the WorkStream name. Pre-fillable from
 * TopicPromotionSuggestion.suggested_name (passed in as initialValue) or blank.
 */

import { useId } from 'react';

interface StepNameProps {
  value: string;
  onChange: (value: string) => void;
  /** validation error message, or null when valid */
  error: string | null;
}

export function StepName({ value, onChange, error }: StepNameProps) {
  const inputId = useId();
  const errorId = useId();
  return (
    <div>
      <label htmlFor={inputId} className="block text-sm font-medium text-text">
        WorkStream name
      </label>
      <input
        id={inputId}
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="e.g. GL Monthly Close"
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        className={`mt-1.5 w-full px-3 py-2 rounded-lg border bg-surface-card text-sm text-text placeholder:text-subtle focus:outline-none focus:ring-1 focus:ring-primary-400 transition-all ${
          error ? 'border-red-300' : 'border-line'
        }`}
        autoFocus
      />
      {error && (
        <p id={errorId} role="alert" className="mt-1.5 text-xs text-red-600">
          {error}
        </p>
      )}
      <p className="mt-2 text-xs text-subtle">
        Pick something you'll recognise in your rail — you can rename it later.
      </p>
    </div>
  );
}
